import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import EntryListModal from "../EntryListModal";
import OffSetListModal from "../OffSetListModal";

import { connect } from "react-redux";
import * as actions_list from "redux/actions/watchListActions";
import * as actions_stock from "redux/actions/watchStockActions";
import 'assets/css/watchlist.css';

// const useStyles = {
//     root: {
//         display: "flex",
//         "justifyContent": "space-between"
//     },

//     spacer: {
//         flexGrow: 1,
//     },
//     importButton: {
//         marginRight: theme.spacing(1),
//     },
//     exportButton: {
//         marginRight: theme.spacing(1),
//     },
//     searchInput: {
//         marginRight: theme.spacing(1),
//     },
//     row: {
//         flexDirection: "row",
//         display: "flex",
//         justifyContent: "flex-start",
//         padding: "10px"
//     }
// };

const Toolbar = (props) => {
    const { className, history, ...rest } = props;

    const [values, setValues] = useState({
        list_id: null,
    });

    const [state, setState] = useState({
        isValid: true,
        id: props.user_id
    });

    const [open, setOpen] = useState(false);
    /*
        useEffect(() => {
            props.loadListStock({ id: props.user_id }, props.token);
        }, props.list);
    */
 


    const handleDropDown = (event) => {
        const { value, name } = event.target;
       
        if (value === '100') {
            setOpen(true);
            return
        } 

        setValues({
            ...values,
            [name]: value,
        });
        props.loadListStock({
            id: props.user_id,
            list_id: value,
        }, props.token);
       
    };

    const handleChange = (event) => {
        setState({
            ...state,
            [event.target.name]: event.target.value,
            isValid: event.target.value.length > 0 ? false : true
        });
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        setOpen(false);
        props.NewItem(state, props.token);
    };

    const hasLists = Array.isArray(props.list) && props.list.length > 0;

    const selectedValue = values.list_id !== null ? values.list_id: hasLists? props.list[0].id: "";

    return (
        <div className="watchlist-toolbar">
            <div className="watchlist-toolbar-select">
                <select aria-label="Default select" value={selectedValue} onChange={handleDropDown} name={"list_id"}>
                    {
                        hasLists && props.list.map((item) => (
                            <option
                                key={item.id}
                                value={item.id}
                            >
                                {item.name}
                            </option>
                        ))
                    }
                    {   
                        !hasLists && (
                            <option value="" disabled>
                                No lists available
                            </option>
                    )}
                    {
                        hasLists && (
                            <option value="" disabled>
                                Select a list…
                            </option>
                    )}
                    <div className="divider"></div>
                    <option value={100} style={{ fontWeight: "bold" }}>+ Add List</option>
                </select>
            </div>
            {open && (
                <EntryListModal  handleClose={handleClose} handleChange={handleChange} isValid={state.isValid} handleSave={handleSave} />
            )}
            <div className="watchlist-toolbar-actions">
                <OffSetListModal />
            </div>
        </div>
    );
};

Toolbar.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object
};
function mapStateToProps(reducer) {
    //console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        list: reducer.watchList.list,
        error: reducer.watchList.error,
        loading: reducer.watchList.loading,
    };
}
const mapDispatchToProps = dispatch => ({
    NewItem: (params, token) =>
        dispatch(actions_list.newItem({ params, token })),
    loadListStock: (params, token) =>
        dispatch(actions_stock.loadList({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);
/**
 *  </div>  
 *  <SearchInput
                    className={classes.searchInput}
                    placeholder="Search ..."
                />
 * <CardHeader
        action={
          <Button
            size="small"
            variant="text"
          >
            Last 12 month <ArrowDropDownIcon />
          </Button>
        }
        title="Latest P/L"
      />
      <Divider />
   <div className={classes.row}>
                <span className={classes.spacer} />
                <Button className={classes.importButton}>Import</Button>
                <Button className={classes.exportButton}>Export</Button>
                <Button color="secondary" variant="outlined" onClick={onClickFolderIn}>
                    Crear Carpeta
                </Button>
                <Button color="primary" variant="contained" onClick={onClickFileIn}>
                    Agregar Archivo
                </Button>
            </div>
 */